export const ADD_MEMBER_UPLOAD = 'add-member-upload';
export const FLOAT_INTEGRATION_MODAL = 'float-integration-modal';
export const IMPORT_FILE_GERMAN = 'import-file-german';
export const JOIN_CLUB = 'join-club';
export const SESSION_IMPORT_DATA = 'add-import-data';
export const SESSION_INFO_MODAL = 'session-info-modal';
export const SHARE_CALENDAR_LINK = 'calendar-share-link-modal';
export const ASSIGN_MEMBERS = 'calendar-assign-members';
export const ADD_SESSION_RESULTS = 'add-session-results';
export const CREATE_MORNING_MONITORING = 'create-morning-monitoring';
export const ADD_NOTE = 'add-note';
export const CREATE_SESSION_FURTHER_ACTIONS = 'create-session-further-actions';
export const CREWS_ASSIGN_TO_SESSIONS = 'crews:assign-to-sessions';
export const CALENDAR_HEAT_MAP_MONTH = 'calendar-heat-map-month';
export const ASSIGN_EQUIPMENT = 'assign-equipment';
